// @mui
import { SvgIcon } from "@mui/material";

function EditIcon(props) {
  return (
    <SvgIcon
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      sx={{ fill: "none" }}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.72461 21H19.8128"
        stroke={props.color || "#0066FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0205 6.61328L15.7692 10.064"
        stroke={props.color || "#0066FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4614 4.67611C13.1612 3.75042 14.4789 3.56731 15.4046 4.26711L16.8319 5.34614C17.7576 6.04595 17.9407 7.36368 17.2409 8.28937L11.4169 15.9933C10.858 16.7325 10.0495 17.2435 9.14193 17.4308L7.80651 17.7066C6.9023 17.8933 6.04032 17.2416 5.9734 16.3208L5.87457 14.9608C5.8074 14.0365 6.0785 13.1193 6.63736 12.38L12.4614 4.67611Z"
        stroke={props.color || "#0066FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default EditIcon;
